
// Declarations
export const GET_CONTACTS = "GET_CONTACTS";
export const UPDATE_STATE = 'UPDATE_STATE';
export const SET_MANDATORY_DECLARATION_ELEMENTS = 'SET_MANDATORY_DECLARATION_ELEMENTS';
export const SET_DISABLED_DECLARATION_ELEMENTS = 'SET_DISABLED_DECLARATION_ELEMENTS';
export const SET_ELEMENT_VALUE = 'SET_ELEMENT_VALUE';
export const SET_AMENDMENT_ELEMENT_VALUE = 'SET_AMENDMENT_ELEMENT_VALUE';
export const SET_ELEMENT_VALUE_IN_SETCION = 'SET_ELEMENT_VALUE_IN_SETCION';
export const SET_ITEM_ELEMENT_VALUE = 'SET_ITEM_ELEMENT_VALUE';
export const SET_AMENDMENT_ITEM_ELEMENT_VALUE = 'SET_AMENDMENT_ITEM_ELEMENT_VALUE';
export const SET_ITEM_ELEMENT_VALUE_IN_SECTION = 'SET_ITEM_ELEMENT_VALUE_IN_SECTION';
export const CREATE_ITEM = 'CREATE_ITEM';
export const CREATE_AMENDMENT_ITEM = 'CREATE_AMENDMENT_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const DELETE_AMENDMENT_ITEM = 'DELETE_AMENDMENT_ITEM';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const UPDATE_AMENDMENT_ITEM = 'UPDATE_AMENDMENT_ITEM';
export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS';
export const SET_UNSAVED_CHANGES = 'SET_UNSAVED_CHANGES';
export const SET_REQUIRED_PULLDOWN_OPTIONS = 'SET_REQUIRED_PULLDOWN_OPTIONS';
export const LIST_DECLARATIONS = 'LIST_DECLARATIONS';
export const LIST_DECLARATIONS_LOADING = 'LIST_DECLARATIONS_LOADING';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const CLEAR_SELECTED_DECLARATION_STATE = 'CLEAR_SELECTED_DECLARATION_STATE'


// Theme
export const SET_THEME = 'SET_THEME'

// Files
export const GET_FILES = 'GET_FILES';
export const GET_FILES_LOADING = 'GET_FILES_LOADING';
export const DELETE_FILES = 'DELETE_FILES';
export const FILES_ERROR = 'FILES_ERROR';
export const UPLOAD_FILES_RESULT = 'UPLOAD_FILES_RESULT';
export const UPLOAD_FILES_LOADING = 'UPLOAD_FILES_LOADING';
export const UPLOAD_FILES_ERROR = 'UPLOAD_FILES_ERROR';

// User
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';